import React, { useEffect, useContext, useState } from 'react';
import { ModalContext } from 'commons-ui';
import { SelectFilterContent } from '../../selectFilter';
import useUser from '../../useUser';

const useFilter = () => {
	const { getUserData, handleFilterSubmit, forceUpdate, showLoader } = useUser();
	const [changeFilter, setChangeFilter] = useState(false);

	const { setModalConfig } = useContext(ModalContext);

	const handleFilterFormClose = () => {
		setModalConfig({ isOpen: false });
		setChangeFilter(false);
	};

	const handleFilterModalOpen = () => {
		setModalConfig({
			isOpen: true,
			header: 'Enter User Filter',
			content: <SelectFilterContent handleFilterSubmit={handleFilterSubmit} onClose={handleFilterFormClose} />
		});
	};

	useEffect(() => {
		if (changeFilter) {
			handleFilterModalOpen();
		}
	}, [changeFilter]);

	useEffect(() => {
		handleFilterModalOpen();
	}, []);

	return {
		getUserData,
		forceUpdate,
		showLoader,
		setChangeFilter
	};
};

export default useFilter;
